/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shown: NonNullable<unknown>, total: NonNullable<unknown> }} Spaces_Search_Results_TruncatedInputs */



/**
* | output |
* | --- |
* | "Showing {shown} of {total} matches. Refine your filter to narrow results." |
*
* @param {Spaces_Search_Results_TruncatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_search_results_truncated = /** @type {((inputs: Spaces_Search_Results_TruncatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Search_Results_TruncatedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.shown} von ${i?.total} Treffern angezeigt. Verfeinere den Filter, um die Ergebnisse einzugrenzen.`)
	return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} matches. Refine your filter to narrow results.`)
});